import { ReadMore } from "@mui/icons-material";
import { CardHeader, IconButton } from "@mui/material";
import { GridToolbarProps } from "@mui/x-data-grid";

export const TableSummaryToolbar = ({ title, slotProps }: GridToolbarProps) => {
  return (
    <CardHeader
      title={title}
      sx={{ py: 2 }}
      action={
        slotProps?.button ? (
          <IconButton {...slotProps.button} color="primary">
            <ReadMore />
          </IconButton>
        ) : undefined
      }
    />
  );
};
